import {
  Box,
  MenuItem,
  Typography,
  makeStyles,
  withStyles,
} from '@material-ui/core';
import { colors } from 'design-system';
import { MouseEvent, ReactNode } from 'react';

const StyledMenuItem = withStyles(() => ({
  root: {
    '&:focus': {
      backgroundColor: '#FFFFFF',
    },
    '&:hover': {
      backgroundColor: '#FFFFFF',
    },
  },
}))(MenuItem);

const useStyles = makeStyles(() => ({
  itemText: {
    fontSize: '12px',
    fontWeight: 700,
    color: colors.bright_turquoise,
    overflow: 'hidden',
    whiteSpace: 'normal',
  },
  itemContent: {
    padding: '4px 0px',
    width: '180px',
    display: 'flex',
    alignItems: 'center',
    '&:hover': {
      backgroundColor: '#F3F3FF',
    },
  },
}));

type Props = {
  onClick: () => void;
  optionText: string;
  children: ReactNode;
  disabled?: boolean;
};

const MenuOptionItem = ({
  optionText,
  onClick,
  children,
  disabled,
}: Props): JSX.Element => {
  const classes = useStyles();

  const handleClick = (event: MouseEvent) => {
    event.stopPropagation();
    if (!disabled) {
      onClick();
    }
  };

  return (
    <StyledMenuItem data-testid="menu-item" onClick={handleClick}>
      <Box className={classes.itemContent}>
        <Box
          sx={{
            minWidth: 20,
            display: 'flex',
            justifyContent: 'center',
            marginRight: 5,
          }}
        >
          {children}
        </Box>
        <Typography variant="caption" className={classes.itemText}>
          {optionText.toUpperCase()}
        </Typography>
      </Box>
    </StyledMenuItem>
  );
};

export default MenuOptionItem;
